module.exports = __webpack_public_path__ + "static/media/1_CONNECTED TO CATS-EYES BRACELET_FA.87d39940.txt";